import React, { FC, useMemo } from 'react';
import { Avatar, Badge } from '@mui/material';
import { Edit, FavoriteBorder } from '@mui/icons-material';

import { imageMimes, videoMimes } from '@cvt/helpers/file';
import { FileUploader } from '@cvt/components/FileUploader';

interface Props {
  label: string;
  value?: Tributes.Media | File;
  disabled?: boolean;
  onChange: (file: File) => void;
}

export const PictureUploader: FC<Props> = React.forwardRef(({ value, label, disabled, onChange }, ref: React.Ref<HTMLInputElement>) => {

  const photoUrl = useMemo(() => {
    if (!value) {
      return undefined;
    }

    return typeof value === 'object' && 'file' in value ? value.file  : URL.createObjectURL(value);
  }, [value]);

  return (
    <FileUploader
      {...ref}
      name="button-picture"
      label={label}
      disabled={disabled}
      inputProps={{
        accept: [...imageMimes, ...videoMimes].join(','),
        multiple: false,
      }}
      buttonRender={() => (
        <Badge
          overlap="circular"
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          slotProps={{
            badge: {
              sx: {
                backgroundColor: 'transparent',
              },
            },
          }}
          badgeContent={!disabled ? (
            <Avatar
              sx={theme => ({
                width: theme.spacing(6),
                height: theme.spacing(6),
                border: `2px solid ${theme.palette.background.paper}`,
                bgcolor: 'primary.main',
                padding: '6px',

              })}
            >
              <Edit style={{ width: '100%', height: '100%' }}/>
            </Avatar>
          ) : null}
        >
          <Avatar
            alt="Profile picture"
            src={photoUrl}
            sx={theme => ({
              width: theme.spacing(24),
              backgroundColor: '#fcdcda',
              height: theme.spacing(24),
              border: '1px solid transparent',
              cursor: disabled ? 'default': 'pointer',
              '&:hover': {
                borderColor: disabled ? 'transparent' : 'primary.main',
              },
            })}
          >
            <FavoriteBorder color="primary" sx={{ fontSize: theme => theme.spacing(12) }}/>
          </Avatar>
        </Badge>
      )}
      onChange={files => onChange(files[0])}
    />
  );
});
